import { cn } from '@/lib/utils';

interface LogoProps {
  size?: number;
  showText?: boolean;
  variant?: 'default' | 'light' | 'dark';
}

export default function Logo({ size, showText, variant }: LogoProps) {
  const imageSize = size * 0.9;
  const gap = size * 0.15;
  const fontSize = size * 0.9;

  return (
    <div
      className="inline-flex items-center"
      style={{ gap: `${gap}px` }}
    >
      <img
        src="/logo-icon.png"
        alt="VeraID"
        width={imageSize}
        height={imageSize}
        className="object-contain"
      />
      {showText && (
        <span
          className={cn(
            'font-sans font-bold tracking-tight',
            variant === 'light' ? 'text-gray-900' : 'text-white'
          )}
          style={{ fontSize: `${fontSize}px` }}
        >
          Vera<span className="text-accent">ID</span>
        </span>
      )}
    </div>
  );
}

export function LogoIcon({ size = 32 }: { size?: number }) {
  return (
    <img
      src="/logo-icon.png"
      alt="VeraID"
      width={size}
      height={size}
      className="object-contain"
    />
  );
}
